<template>
  <el-form ref="firtReappraisal" :inline="true" :model="relevantReappraisalApplication"
           label-width="200px" size="small">
    <el-form-item label="Τύπος αίτησης">
      {{ relevantReappraisalApplication.applicationType === 'reappraisal'
        ? 'Επανεξέταση'
        : ''}}
    </el-form-item>
     <el-form-item label="Εκπρόθεσμη">
      {{relevantReappraisalApplication.overdue ? 'Ναι' : 'Όχι'}}
    </el-form-item>
    <el-form-item label="Αριθμός αίτησης">
      {{relevantReappraisalApplication.id}}
    </el-form-item>
    <el-form-item label="Αριθμός Πρωτοκόλλου">
      {{relevantReappraisalApplication.protocol}}
    </el-form-item>
    <el-form-item label="Τύπος απόφασης">
      {{reappraisalDecisionType}}
    </el-form-item>
     <el-form-item label="Υπεύθυνος Αντιπρόεδρος">
      {{relevantReappraisalAppl.designatedVicePresident.surname + ' ' + relevantReappraisalAppl.designatedVicePresident.surname}}
    </el-form-item>
    <attached-documents :attachedDocumentsTable="attachedDocumentsTable"
        :neededDocuments="relevantReappraisalApplication.neededDocuments"
        :appId="relevantReappraisalApplication.id">
    </attached-documents>
  </el-form>
</template>
<script>
// import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import dictionary from '../../store/dictionary'
import Titles from './Titles'
import AttachedDocuments from './AttachedDocuments'
export default {
  props: ['relevantReappraisalApplication', 'relevantReappraisalAppl'],
  components: {
    Titles,
    AttachedDocuments
  },
  data () {
    return {
    }
  },
  methods: {
    translate (term) {
      return dictionary[term]
    }
  },
  computed: {
    reappraisalDecisionType () {
      return this.relevantReappraisalApplication.applicationHistory.slice(0).reverse()
        .find(step => (step.applicationStatus === 'presidentW_Viewer' || step.applicationStatus === 'presidentW_ReappraisalBoard')).judgment.reappraisalDecisionType
    },
    attachedDocumentsTable () {
      return this.relevantReappraisalApplication.attachedDocuments.slice(0).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    idOrPassport () {
      return this.personalDetails.id.idCardOrPassport ? 'Ταυτότητα' : 'Διαβατήριο'
    },
    birthCountryName () {
      let country = this.countries.find(item => item.id === this.personalDetails.birthCountryId)
      return country !== undefined ? country.name : ''
    },
    countryName () {
      let country = this.countries.find(item => item.id === this.personalDetails.countryId)
      return country !== undefined ? country.name : ''
    },
    ...mapGetters(['activeRole']),
    ...mapState([
      'countries'
    ])
  }
}
</script>

<style scoped lang="scss">
.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  // border-radius: 10px;
  // border-style: solid;
  // border-color: #7fa3bb green #86b8da yellow;
  // border-width: 0px 0px 2px 0px;
  // padding-right: 20px;
}
hr {
  border-color: #7da0b8;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FirstReappraisal.vue